import Module from '../../modules/Module';

export default class Tables extends Module {
  static Info = {
      "nameResource": "tables",
      "icon": "fas fa-table",
      "path": "",
      "show": true
  };
}